export default __webpack_public_path__ + "static/media/digital-preview.0695c860.png";